// extracted by mini-css-extract-plugin
export default {"productGallery":"KH-z","inQuickShop":"LH-z"};